<template>
  <section>
    <h6 class="q-mb-md">Company Info:</h6>

    <div class="bg-gray q-pa-md">
      <div class="row q-col-gutter-md">
        <div class="col-12 col-md-6">
          <q-select
            v-model="yearEstablishedSync"
            label="Year established"
            :options="yearOptions"
            :disable="yearEstablishedDisabled"
          />
        </div>

        <div class="col-12 col-md-6">
          <q-input v-model="repDisplayNameSync" label="Name of Sales Representative" />
        </div>

        <div class="col-12 col-md-6">
          <q-select
            v-model="employeesSync"
            label="Number of employees"
            :options="employeesOptions"
          />
        </div>

        <div class="col-12 col-md-6">
          <q-select
            v-model="employedDriversSync"
            label="Number of employed drivers"
            :options="employeesOptions"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    yearEstablished: {
      type: Number,
    },
    yearEstablishedDisabled: {
      type: Boolean,
    },
    repDisplayName: {
      type: String,
    },
    employees: {
      type: String,
    },
    employedDrivers: {
      type: String,
    },
  },

  computed: {
    yearEstablishedSync: {
      get() {
        return this.yearEstablished;
      },
      set(value) {
        this.$emit('update:yearEstablished', value);
      },
    },
    repDisplayNameSync: {
      get() {
        return this.repDisplayName;
      },
      set(value) {
        this.$emit('update:repDisplayName', value);
      },
    },
    employeesSync: {
      get() {
        return this.employees;
      },
      set(value) {
        this.$emit('update:employees', value);
      },
    },
    employedDriversSync: {
      get() {
        return this.employedDrivers;
      },
      set(value) {
        this.$emit('update:employedDrivers', value);
      },
    },
    yearOptions() {
      const startYear = 1900;
      const endYear = new Date().getFullYear();
      const years = [];

      // eslint-disable-next-line
      for (let i = 0; i <= endYear - startYear; i++) {
        years.push(startYear + i);
      }

      return years.reverse();
    },
    employeesOptions() {
      return ['1-10', '11-50', '51-100', '101-500', '501-1000', '1000+'];
    },
  },
};
</script>
